import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/Ui.css';



function Sidebar({ collapsed, onOpenFormModal }) {
  const navigate = useNavigate();

  const [openMenu, setOpenMenu] = useState(null);
  const [openAdminSubMenu, setOpenAdminSubMenu] = useState(null);

  const adminBtnRef = useRef(null);
  const [adminPos, setAdminPos] = useState({ top: 0 });

  useEffect(() => {
    setOpenMenu(null);
  }, [collapsed]);

  useEffect(() => {
    const updateAdminPos = () => {
      if (collapsed && openMenu === 'admin' && adminBtnRef.current) {
        const rect = adminBtnRef.current.getBoundingClientRect();
        setAdminPos(prev => prev.top !== rect.top ? { top: rect.top } : prev);
      }
    };
    updateAdminPos();
    window.addEventListener('scroll', updateAdminPos, { passive: true });
    window.addEventListener('resize', updateAdminPos);
    return () => {
      window.removeEventListener('scroll', updateAdminPos);
      window.removeEventListener('resize', updateAdminPos);
    };
  }, [collapsed, openMenu]);

  const handleLogout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('M_ComCode');
    setOpenMenu(null);
    navigate('/login');
  };

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };

  const handleSimpleNavigate = (path, menu) => {
    setOpenMenu(collapsed ? null : menu || null);
    navigate(path);
  };

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="logo">
        {collapsed ? (
          <img src="/images/tni_logo_s.png" alt="축소 로고" className="logo-img" />
        ) : (
          <img src="/images/tni_logo.png" alt="기본 로고" className="logo-img" />
        )}
      </div>

      <div className="nav flex-column">
        {/* Dash Board */}
        <div className="nav-item">
          <button
            className="btn btn-link nav-link text-info w-100 text-start d-flex align-items-center"
            onClick={() => handleSimpleNavigate('/', null)}
          >
            <i className="fas fa-chart-pie me-2"></i>
            {!collapsed && 'Dash Board'}
          </button>
        </div>

        <div className="nav-item">
          <button
            className="btn btn-link nav-link text-info w-100 text-start d-flex align-items-center"
            onClick={() => handleSimpleNavigate('/manager/board', null)}
          >
            <i className="fas fa-list me-2"></i>
            {!collapsed && '게시판'}
          </button>
        </div>

        {/* 관리자 */}
          <div className="nav-item">
            <button
              ref={adminBtnRef}
              className="btn btn-link nav-link text-info w-100 text-start d-flex justify-content-between align-items-center"
              onClick={() => toggleMenu('admin')}
            >
              <span>
                <i className="fas fa-cogs me-2"></i>
                {!collapsed && '관리자'}
              </span>
              {!collapsed && (
                <i className={`fas fa-chevron-${openMenu === 'admin' ? 'down' : 'right'}`}></i>
              )}
            </button>
            {openMenu === 'admin' && (
              <ul
                className={`sidebar-submenu list-unstyled ${collapsed ? 'floating' : 'open'}`}
                style={
                  collapsed
                    ? { position: 'fixed', top: adminPos.top, left: 80 }
                    : undefined
                }
              >
                <li>
                  <button className="dropdown-item" onClick={() => handleSimpleNavigate('/users', 'admin')}>
                    사용자 관리
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={() => handleSimpleNavigate('/manager/log', 'admin')}>
                    사용자로그
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={() => handleSimpleNavigate('/dept', 'admin')}>
                    부서관리
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={() => handleSimpleNavigate('/board-codes', 'admin')}>
                    게시판관리
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={() => handleSimpleNavigate('/resources', 'admin')}>
                    자원관리
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={() => handleSimpleNavigate('/aprv/forms', 'admin')}>
                    전자결재양식관리
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={() => handleSimpleNavigate('/risk-cate', 'admin')}>
                    위험성 분류관리 (사용안함)
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={() => handleSimpleNavigate('/safety/master', 'admin')}>
                    위험성평가 설정관리
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item d-flex justify-content-between align-items-center"
                    onClick={() => setOpenAdminSubMenu(openAdminSubMenu === 'manager' ? null : 'manager')}
                  >
                    <span>통합관리</span>
                    <i className={`fas fa-chevron-${openAdminSubMenu === 'manager' ? 'down' : 'right'} ms-2`}></i>
                  </button>
                  {openAdminSubMenu === 'manager' && (
                    <ul className="list-unstyled ps-3 mb-0">
                      <li>
                        <button className="dropdown-item" onClick={() => handleSimpleNavigate('/manager', 'admin')}>
                          회사관리
                        </button>
                      </li>
                      <li>
                        <button className="dropdown-item" onClick={() => handleSimpleNavigate('/manager/left-menu', 'admin')}>
                          메뉴관리
                        </button>
                      </li>
                      <li>
                        <button className="dropdown-item" onClick={() => handleSimpleNavigate('/manager/portlet', 'admin')}>
                          포틀릿관리
                        </button>
                      </li>
                    </ul>
                  )}
                </li>
              </ul>
            )}
          </div>
      </div>

      <div className="logout">
        <button
          className="btn btn-outline-warning w-100 text-start"
          onClick={handleLogout}
        >
          <i className="fas fa-sign-out-alt me-2"></i>
          {!collapsed && '로그아웃'}
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;